import { REGEX_INTERNATIONAL_ALPHABETIC } from 'utils/constants';
import { z } from 'zod';

export enum CardType {
  VISA = 0,
  MASTERCARD = 1,
  AMEX = 2,
  TROY = 3,
}

const validateHolderName = (name: string | undefined, ctx: any, t: any) => {
  if (!name || name.trim().length < 2) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('schema.required'),
      path: ['holderNameSurname'],
    });
    return;
  }

  const trimmedName = name.trim();

  if (!REGEX_INTERNATIONAL_ALPHABETIC.test(trimmedName)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('schema.alphabetic'),
      path: ['holderNameSurname'],
    });
  }

  if (trimmedName.length > 35) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('schema.max-char', { number: 35 }),
      path: ['holderNameSurname'],
    });
  }
};

const validateCardNumber = (
  cardNo: string | undefined,
  //validateCard: (cardNumber: string) => boolean,
  ctx: any,
  t: any
) => {
  if (!cardNo) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('schema.invalid_cc'),
      path: ['cardNo'],
    });
  }
};

const validateExpDate = (expDate: string | undefined, ctx: any, t: any) => {
  if (!expDate || expDate.trim() === '') {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('schema.required'),
      path: ['expDate'],
    });
  }
};

const validateSecurityCode = (
  securityCode: string | undefined,
  cardType: CardType | null,
  ctx: any,
  t: any
) => {
  if (!securityCode || securityCode.trim() === '') {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('schema.required'),
      path: ['securityCode'],
    });
    return;
  }

  const expectedLength = cardType === CardType.AMEX ? 4 : 3;
  if (securityCode.trim().length !== expectedLength) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('schema.must-number', { number: expectedLength }),
      path: ['securityCode'],
    });
  }
};

const validateSelectedCard = (selectedCardId: string | undefined, ctx: any, t: any) => {
  if (!selectedCardId || selectedCardId.trim() === '') {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('schema.required'),
      path: ['selectedCardId'],
    });
  }
};

const validateCardAlias = (cardAlias: string | undefined, isSaveCard: boolean, ctx: any, t: any) => {
  if (isSaveCard && (!cardAlias || cardAlias.trim() === '')) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t('schema.required'),
      path: ['cardAlias'],
    });
  }
};

export {
  validateHolderName,
  validateCardNumber,
  validateExpDate,
  validateSecurityCode,
  validateSelectedCard,
  validateCardAlias,
};

